import { pb } from './pocketbase';

export const getProspectMemos = async (prospectId) => {
    try {
        const records = await pb.collection('prospect_student_memos').getList(1, 50, {
            filter: `prospect_id="${prospectId}"`,
            sort: '-created',
            expand: 'created_by,prospect_id'
        });
        return records.items;
    } catch (error) {
        if (error.status === 404) {
            return [];
        }
        console.error(`Erreur lors de la récupération des mémos du prospect étudiant ${prospectId}:`, error);
        throw error;
    }
};

export const createProspectMemo = async (memoData) => {
    try {
        if (pb.authStore.isValid && pb.authStore.model) {
            const memoWithPartnerId = {
                ...memoData,
                partner_id: pb.authStore.record.partner_id
            };
            const createdMemo = await pb.collection('prospect_student_memos').create(memoWithPartnerId);
            return createdMemo;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de créer le mémo sans partner_id.');
            return null;
        }
    } catch (error) {
        console.error('Erreur lors de la création du mémo:', error);
        throw error;
    }
};

export const deleteProspectMemo = async (memoId) => {
    try {
        await pb.collection('prospect_student_memos').delete(memoId);
        return true;
    } catch (error) {
        console.error(`Erreur lors de la suppression du mémo ${memoId}:`, error);
        throw error;
    }
};